// extracted by mini-css-extract-plugin
export default {"editor":"MarkdownEditor_editor__zJR3l"};